import React from 'react';

export const FormShortcutHints = ({ shortcuts = [] }) => {
  const base = [
    { key: 'Enter', label: 'Submit' },
    { key: 'Esc', label: 'Close' },
  ];
  const all = [...shortcuts, ...base];

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground/70 w-full" data-testid="form-shortcut-hints">
      {all.map((s, i) => (
        <span key={i} className="inline-flex items-center gap-1">
          <kbd className="px-1 py-0.5 rounded border border-border/60 bg-muted/40 font-mono text-[10px] leading-none">{s.key}</kbd>
          <span>{s.label}</span>
        </span>
      ))}
    </div>
  );
};
